<div [ngClass]="theme == 'dark' ? 'dropzone-dark' : 'p-4 dropzone'" *ngIf="!readonly">
    <div class="img-preview">
      <img *ngIf="!fileUrl" class="img-fluid" src="assets/img/image-placeholder@2x.png" alt="image placeholder" />
    </div>
    <caption>{{label}}</caption><span *ngIf="required"> *</span>
    <caption>{{(file)? file.name : ''}}</caption>
    <input [disabled]="readonly" type="file" style="display: none;" accept="{{accept}}" #hiddenSelfie (change)="onFileChange($event)" />
    <button [disabled]="readonly" type="button" (click)="hiddenSelfie.click()" class="btn btn-primary inline">{{labelButton}}</button>
</div>
<div class="dropzone" *ngIf="readonly">
  <div class="img-preview">
      <img class="img-fluid" src="assets/img/image-placeholder@2x.png" alt="image placeholder" />
  </div>
</div>
